const rankedList = (a, b) => {
  if (a.rank === b.rank) {
    return 0
  }
  if (a.rank === null) {
    return 1
  }
  if (b.rank === null) {
    return -1
  }

  return a.rank < b.rank ? -1 : 1
}

export default rankedList
